import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import OrderHistory from '../components/Profile/OrderHistory';
import ProfileInfoForm from '../components/Profile/ProfileInfoForm';
import { useLang } from '../i18n/LanguageContext';

export default function Profile() {
    const { user, logout } = useAuth();
    const { t } = useLang();
    const location = useLocation();
    const navigate = useNavigate();

    // Derive active tab directly from URL
    const activeTab = location.pathname.includes('/orders') ? 'orders' : 'info';

    const handleTabChange = (tab) => {
        if (tab === 'orders') {
            navigate('/profile/orders');
        } else {
            navigate('/profile');
        }
    };

    const handleLogout = async () => {
        try {
            await logout();
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-background via-surface to-cream py-10 px-5">
            <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-2xl border-2 border-primary/20 p-6 md:p-8 shadow-soft mb-6">
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                        <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary-dark rounded-full flex items-center justify-center text-4xl text-white shadow-lg flex-shrink-0">
                            👤
                        </div>
                        <div className="flex-1 text-center md:text-left">
                            <h1 className="text-3xl font-bold text-text mb-2">{user.fullName}</h1>
                            <p className="text-text-light text-base">{user.email}</p>
                        </div>
                        <button onClick={handleLogout} className="px-6 py-2.5 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg transition-all duration-300 hover:shadow-lg">
                            {t('compte.profil.deconnexion')}
                        </button>
                    </div>
                </div>

                <div className="flex gap-2 mb-6 bg-white rounded-xl border-2 border-primary/20 p-2 shadow-soft">
                    <button
                        className={`flex-1 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${activeTab === 'orders'
                            ? 'bg-blue-500/20 text-blue-700 border-2 border-blue-400'
                            : 'text-text hover:bg-surface'
                            }`}
                        onClick={() => handleTabChange('orders')}
                    >
                        {t('compte.profil.mesCommandes')}
                    </button>
                    <button
                        className={`flex-1 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${activeTab === 'info'
                            ? 'bg-blue-500/20 text-blue-700 border-2 border-blue-400'
                            : 'text-text hover:bg-surface'
                            }`}
                        onClick={() => handleTabChange('info')}
                    >
                        {t('compte.profil.informations')}
                    </button>
                </div>

                <div>
                    {activeTab === 'orders' && <OrderHistory />}
                    {activeTab === 'info' && (
                        <div className="bg-white rounded-2xl border-2 border-primary/20 p-6 md:p-8 shadow-soft">
                            <h2 className="text-2xl font-bold text-text mb-6">{t('compte.profil.informationsTitre')}</h2>
                            <ProfileInfoForm user={user} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
